<template>
  <div class="pointer-events-none fixed inset-x-0 bottom-4 z-[70] flex flex-col items-center gap-3 px-4">
    <transition-group name="toast-stack" tag="div" class="flex w-full max-w-md flex-col gap-3">
      <article
        v-for="toast in toasts"
        :key="toast.id"
        class="pointer-events-auto overflow-hidden rounded-2xl border bg-midnight-900/95 shadow-glow backdrop-blur"
        :class="toneClass(toast.tone)"
      >
        <div class="flex items-start gap-3 px-4 py-3">
          <div class="mt-0.5 h-2.5 w-2.5 shrink-0 rounded-full" :class="dotClass(toast.tone)"></div>
          <div class="min-w-0 flex-1">
            <p v-if="toast.title" class="text-sm font-semibold text-white">{{ toast.title }}</p>
            <p class="text-sm leading-5 text-steel-200" :class="toast.title ? 'mt-1' : ''">{{ toast.message }}</p>
          </div>
          <button
            type="button"
            class="rounded-full border border-white/10 px-2 py-1 text-[10px] uppercase tracking-[0.25em] text-steel-300 transition hover:text-white"
            @click="$emit('dismiss', toast.id)"
          >
            Close
          </button>
        </div>
      </article>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'AppToastStack',
  props: {
    toasts: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['dismiss'],
  methods: {
    toneClass(tone) {
      if (tone === 'success') return 'border-emerald-400/30'
      if (tone === 'error') return 'border-rose-400/30'
      if (tone === 'warning') return 'border-amber-400/30'
      return 'border-white/10'
    },
    dotClass(tone) {
      if (tone === 'success') return 'bg-emerald-400'
      if (tone === 'error') return 'bg-rose-400'
      if (tone === 'warning') return 'bg-amber-400'
      return 'bg-neon-400'
    },
  },
}
</script>

<style scoped>
.toast-stack-enter-active,
.toast-stack-leave-active {
  transition: opacity 220ms ease, transform 220ms ease;
}

.toast-stack-enter-from,
.toast-stack-leave-to {
  opacity: 0;
  transform: translateY(10px) scale(0.98);
}
</style>
